"use client"

import { useCountry } from "@/components/layout/country-provider"
import { StethoscopeOutlineIcon } from "@/components/ui/icons"

/**
 * Icon for the report page's "licensed medical practice" trust card.
 * Market-aware: the white-cross square is the Swiss flag, so AT shows a
 * neutral stethoscope instead (AHD-13706); every other market keeps the flag,
 * matching the Swiss-practice positioning.
 */
export function LicensedPracticeIcon({ size = 22 }: { size?: number }) {
  const { code } = useCountry()
  if (code === "at") return <StethoscopeOutlineIcon size={size} />
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      className="shrink-0 overflow-hidden rounded-[2px]"
      aria-hidden="true"
      data-icon="swiss-flag"
    >
      <rect width="16" height="16" fill="currentColor" />
      <rect x="6.5" y="3" width="3" height="10" rx="0.4" fill="#f4f4f4" />
      <rect x="3" y="6.5" width="10" height="3" rx="0.4" fill="#f4f4f4" />
    </svg>
  )
}
